// Components
import { RootState } from '../index';

const getWorstWeaponPresentation = (state: RootState) => state.dashboardDataSlice.worst_weapon_presentation;

const getRankings = (state: RootState) => state.dashboardDataSlice.rankings;

const getScores = (state: RootState) => state.dashboardDataSlice.scores;

const getTotalTrainTime = (state: RootState) => state.dashboardDataSlice.total_train_time;

export {
  getScores,
  getRankings,
  getTotalTrainTime,
  getWorstWeaponPresentation,
};
